/*
 * ta-parallax — lightweight scroll parallax
 *
 * Markup API:
 *   data-parallax                 enable parallax on this element
 *   data-parallax-speed="0.18"    strength; higher = more drift (default 0.15)
 *   data-parallax-scale="1.06"    optional scale kept alongside the translate
 *   data-parallax-anchor          put on an ancestor to measure against it
 *                                 (defaults to the element's parent)
 *
 * The element should overflow its anchor (e.g. taller than the container) so
 * the drift never exposes an edge. Skipped under prefers-reduced-motion.
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = [];
  var ticking = false;

  function collect(scope) {
    var nodes = (scope || document).querySelectorAll('[data-parallax]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__taParallax) continue;
      el.__taParallax = true;

      var speed = parseFloat(el.getAttribute('data-parallax-speed'));
      if (isNaN(speed)) speed = 0.15;

      items.push({
        el: el,
        speed: speed,
        scale: el.getAttribute('data-parallax-scale'),
        anchor: el.closest('[data-parallax-anchor]') || el.parentElement
      });
      el.style.willChange = 'transform';
    }
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var rect = item.anchor.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;

      // Drift opposite to scroll, measured from the anchor's distance to the
      // viewport centre, so the effect is symmetric as it passes through.
      var center = rect.top + rect.height / 2;
      var offset = (center - vh / 2) * item.speed * -1;
      var transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      if (item.scale) transform += ' scale(' + item.scale + ')';
      item.el.style.transform = transform;
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init(scope) {
    collect(scope);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
